import React from 'react';

import { useLocation } from 'react-router-dom';

import { useLandingV2Context } from 'detailsv2/LandingV2/context';
import { checkIsCurrentTrip } from 'utils/proposals';

import { useScrollToCurrentDatePage } from './useScrollToCurrentDatePage';

export const useWebViewScroll = () => {
  const { search } = useLocation();
  const { data, setActivePageId } = useLandingV2Context();
  const isCurrentTrip = React.useMemo(() => checkIsCurrentTrip(data), [data]);
  const { handleScrollToCurrentDatePage } = useScrollToCurrentDatePage();

  React.useEffect(() => {
    if (new URLSearchParams(search).get('webview') !== 'true') return;

    const handleScrollToAnchor = () => {
      const anchor = new URLSearchParams(search).get('block_id') ?? window.location.hash.substring(1);
      if (!anchor) {
        if (isCurrentTrip) handleScrollToCurrentDatePage();
        return;
      }

      const targetPage = data.landing.pages.find(({ id }) => id === Number(anchor));

      if (!targetPage) return;

      setTimeout(() => {
        setActivePageId({ pageId: targetPage.id, notifyExternalEnv: true, withScroll: true });
      }, 0);
    };

    handleScrollToAnchor();
    window.history.replaceState({}, '', window.location.pathname + window.location.search);
  }, []);
};
